import { COURSES } from '../../routes';
import CourseCard from '../Cards/CourseCard';
import { useTranslation } from "react-i18next";

const DisplayCourses = ({coursesRef}) => {

    const translationPrefix = 'Teaching'
    const { t } = useTranslation('global')
    const courses = ['fbd', 'introbd', 'cdi', 'bding', 'bdnr', 'sigvd', 'mpgvd']

    return (
        <section ref={coursesRef} className="bg-white md:px-2 md:py-2 lg:px-16 lg:py-32">
            

            <div className="flex flex-wrap items-center w-full">

            {/* Texto genérico de cursos */}
            <div className="w-full md:w-4/12 px-12 md:px-2 ml-auto mr-auto mt-8">
                <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-xl rounded-full bg-white">
                    <i className="fas fa-drafting-compass text-xl"></i>
                </div>
                <h3 className="text-3xl mb-2 font-semibold leading-normal">
                {t(`${translationPrefix}.courses`)}
                </h3>
                <p className="text-lg leading-relaxed mt-4 mb-4 text-blueGray-500 md:text-base">
                {t(`${translationPrefix}.description_courses`)}
                </p>
                <a
                      href={COURSES}
                      className="pt-4 font-bold text-blue hover:underline ease-linear transition-all duration-150"
                >
                    { t(`${translationPrefix}.ver_mas`) + " "}
                    <i className="fa fa-angle-double-right ml-1 leading-relaxed"></i>
                </a>
            </div>
            
            {/* Cards de cursos */}
            <div className="w-full md:w-6/12 px-4">
                <div className="justify-center flex flex-wrap ">
                <div className="my-4 w-full lg:w-6/12 px-4">
                {
                    courses.slice(0,4).map((course) => {
                    return(
                        <CourseCard 
                            key={t(`Teaching.cursos.${course}.nombre`)} 
                            color={t(`Teaching.cursos.${course}.color`)} 
                            courseName={t(`Teaching.cursos.${course}.nombre`)}
                            web={t(`Teaching.cursos.${course}.eva`)} />
                        )
                    })
                }
                </div>
                <div className="my-4 w-full lg:w-6/12 px-4 lg:mt-16">
                {
                    courses.slice(4, 7).map((course) => {
                        return(
                            <CourseCard 
                                key={t(`Teaching.cursos.${course}.nombre`)} 
                                color={t(`Teaching.cursos.${course}.color`)} 
                                courseName={t(`Teaching.cursos.${course}.nombre`)}
                                web={t(`Teaching.cursos.${course}.eva`)} />
                        )
                    })
                }
                </div>
                </div>
            </div>
            
            </div>
        </section>
    )
}

export default DisplayCourses;